import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Button } from "semantic-ui-react";
import { Dropdown as FormikDropdown } from "formik-semantic-ui";
import { OrderStatuses } from "../constants";

const statusMapping = {
    [OrderStatuses.DRAFT]: { color: "yellow", icon: "clock", text: "Draft" },

    [OrderStatuses.CANCELLED]: {
        color: "red",
        icon: "close",
        text: "Cancelled",
    },
    [OrderStatuses.PLACED]: {
        color: "teal",
        icon: "list alternate",
        text: "Placed",
    },
    [OrderStatuses.REJECTED]: {
        color: "red",
        icon: "ban",
        text: "Rejected",
    },
    [OrderStatuses.INVOICED]: {
        color: "blue",
        icon: "newspaper",
        text: "Invoiced",
    },
    [OrderStatuses.DELIVERED]: {
        color: "green",
        icon: "truck",
        text: "Delivered",
    },
    [OrderStatuses.PARTIALLY_INVOICED]: {
        color: "teal",
        icon: "newspaper",
        text: "Partially Invoiced",
    },
};

const OrderComponentStatus = ({
    status,
    onChange,
    isFormik = false,
    name,
    label,
    noIcon,
    ...otherProps
}) => {
    if (!status) return null;
    const data = statusMapping[status];

    if (!data) return null;

    if (!onChange && !isFormik) {
        return (
            <Button
                compact
                size="mini"
                color={data.color}
                content={data.text}
                icon={!noIcon && data.icon}
            />
        );
    }

    return isFormik ? (
        <FormikDropdown
            name={name}
            label={label}
            inputProps={{
                icon: !noIcon && data.icon,
                className: `icon  ${data.color} `,
                button: true,
                labeled: true,
                selection: false,
                "data-cy": "default_order",
            }}
            options={Object.values(OrderStatuses).map(value => ({
                key: value,
                value: value,
                text: statusMapping[value].text,
                icon: statusMapping[value].icon,
            }))}
            {...otherProps}
        />
    ) : (
        <Dropdown
            data-cy="order_status"
            button
            labeled
            floating
            value={status}
            text={data.text}
            onChange={onChange}
            icon={!noIcon && data.icon}
            className={`icon mini compact ${data.color}`}
            options={Object.values(OrderStatuses).map(is => ({
                key: is,
                value: is,
                text: statusMapping[is].text,
                icon: statusMapping[is].icon,
            }))}
            {...otherProps}
        />
    );
};

OrderComponentStatus.propTypes = {
    noIcon: PropTypes.bool,
    status: PropTypes.string,
    onChange: PropTypes.func,
};

export default OrderComponentStatus;
